// /* eslint-disable */
// import React, { useState,forwardRef,useImperativeHandle  } from 'react'
// import { PlusOutlined } from '@ant-design/icons';
// import { Image, Upload } from 'antd';
// const getBase64 = (file) =>
//     new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
// });


// const UploadComponent = ({ sendDataToParent,uploadImg },ref) => {
//     const [previewOpen, setPreviewOpen] = useState(false);
//     const [previewImage, setPreviewImage] = useState('');
//     const [fileList, setFileList] = useState([]);
//     const handlePreview = async (file) => {
//       // useEffect(() => {
//         // 控制台报错，移除错误的useEffect
//       //   console.log("===================上传图片===================")
//       //   setFileList([]);
//       // })
//       console.log(file)
//       if (!file.url && !file.preview) {
//         file.preview = await getBase64(file.originFileObj);
//       }
//       setPreviewImage(file.url || file.preview);
//       setPreviewOpen(true);
//     };
//     const handleChange = ({ fileList: newFileList }) => {
//         console.log(newFileList)
//         setFileList(newFileList)
//         //父组件方法
//         sendDataToParent(newFileList);
//     };


//     // 暴露给父组件的 clearFileList 方法
//     useImperativeHandle(ref, () => ({
//       clearFileList: () => {
//         console.log("文件清空了")
//         setFileList([]); // 清空文件列表
//       },
//     }));
//     const uploadButton = (
//       <button
//         style={{
//           border: 0,
//           background: 'none',
//         }}
//         type="button"
//       >
//         <PlusOutlined />
//         <div
//           style={{
//             marginTop: 8,
//           }}
//         >
//           Upload
//         </div>
//       </button>
//     ); 
//   return (
//     <div>
//       <Upload
//         listType="picture-card"
//         fileList={fileList}
//         onPreview={handlePreview}
//         onChange={handleChange}
//         beforeUpload={() => false}  // 阻止文件上传
//       >
//         {fileList.length >= 8 ? null : uploadButton}
//       </Upload>
//       {previewImage && (
//         <Image
//           wrapperStyle={{
//             display: 'none',
//           }}
//           preview={{
//             visible: previewOpen,
//             onVisibleChange: (visible) => setPreviewOpen(visible),
//             afterOpenChange: (visible) => !visible && setPreviewImage(''),
//           }}
//           src={previewImage}
//         />
//       )}
//     </div>
//   )
// }
// export default forwardRef(UploadComponent) 

/* eslint-disable */
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Upload, Image } from "antd";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

const UploadComponent = ({ sendDataToParent, onFileRemove }, ref) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // 只负责同步文件列表
const handleChange = ({ fileList: newList }) => {
  setFileList(newList);
  sendDataToParent?.(newList);   
};
  const handleRemove = (file) => {
    onFileRemove?.({ uid: file.uid });
    return true;
  };

  useImperativeHandle(ref, () => ({
    clearFileList: () => setFileList([]),
  }));

  return (
    <div>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={handleRemove}
        beforeUpload={() => false}   // 阻止自动上传
      >
        {fileList.length >= 8 ? null : (
          <div style={{ textAlign: "center" }}>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>

      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: setPreviewOpen,
            afterOpenChange: (v) => !v && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </div>
  );
};

export default forwardRef(UploadComponent);